import { useMemo } from 'react';

import type { IEntityFieldProviderContext } from './types';
import { EntityFieldContext } from './entity-field-group-type.context';

type IEntityFieldProviderProps = {
  children: React.ReactNode;
} & IEntityFieldProviderContext;

export const EntityFieldProvider = ({
  children,
  entityFieldGroupType,
  isSyncing,
  entityId,
  tempEntityId,
  element,
}: IEntityFieldProviderProps) => {
  const context = useMemo(
    () => ({
      entityFieldGroupType,
      isSyncing,
      entityId,
      tempEntityId,
      element,
    }),
    [entityFieldGroupType, isSyncing, entityId, tempEntityId, element],
  );

  return <EntityFieldContext.Provider value={context}>{children}</EntityFieldContext.Provider>;
};
